var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQr = function SvgQr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18,20a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Zm-6,0a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1ZM2,20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2H7a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2Zm0-6.5v4a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-4A.5.5,0,0,0,2,13.5ZM15,17a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1ZM4,17a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H5a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Zm14-3a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Zm-6,0a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1Zm1-5a2,2,0,0,1-2-2V2a2,2,0,0,1,2-2h5a2,2,0,0,1,2,2V7a2,2,0,0,1-2,2Zm0-6.5v4a.5.5,0,0,0,.5.5h4a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-4A.5.5,0,0,0,13,2.5ZM2,9A2,2,0,0,1,0,7V2A2,2,0,0,1,2,0H7A2,2,0,0,1,9,2V7A2,2,0,0,1,7,9ZM2,2.5v4a.5.5,0,0,0,.5.5h4A.5.5,0,0,0,7,6.5v-4A.5.5,0,0,0,6.5,2h-4A.5.5,0,0,0,2,2.5ZM15,6a1,1,0,0,1-1-1V4a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1V5a1,1,0,0,1-1,1ZM4,6A1,1,0,0,1,3,5V4A1,1,0,0,1,4,3H5A1,1,0,0,1,6,4V5A1,1,0,0,1,5,6Z",
    transform: "translate(2 2)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr.5a479e2c.svg";
export { ForwardRef as ReactComponent };